import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';

import { getMarketCountryRestrictionApi } from '@flipster/apis/v2/market';

import { tradeSymbolBunja } from '../symbol';

export const countryRestrictionBunja = bunja(() => {
  const { symbol, isTradFiInstrumentAtom } = bunja.use(tradeSymbolBunja);

  const countryRestrictionQueryAtom = atomWithQuery(() => ({
    queryKey: ['getMarketCountryRestrictionApi', symbol],
    queryFn: () => getMarketCountryRestrictionApi(symbol),
    select: (res) => res.data,
  }));

  const isTradableAtom = atom((get) => {
    const { data } = get(countryRestrictionQueryAtom);
    return data?.isTradable ?? true;
  });

  const isReferrerPersistableAtom = atom((get) => {
    const { data } = get(countryRestrictionQueryAtom);
    return data?.isTradable === true;
  });

  return { isTradableAtom, isReferrerPersistableAtom, isTradFiInstrumentAtom };
});
